import React, { useState, useRef, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const CollapsibleContent = ({ collapsed, children }) => {
  const contentRef = useRef();
  const containerRef = useRef();

  const [overflow, setOverflow] = useState(collapsed ? 'hidden' : 'visible');

  const height = useMemo(() => {
    if (collapsed) {
      return 0;
    }

    if (!contentRef.current) {
      return undefined;
    }

    return contentRef.current.getBoundingClientRect().height;
  }, [collapsed]);

  useEffect(() => {
    // using custom event listener because onTransitionStart is not supported
    const transitionStartEventListener = containerRef.current.addEventListener('transitionstart', () => {
      if (collapsed) {
        setOverflow('hidden');
      }
    });

    return containerRef.current.removeEventListener('transitionstart', transitionStartEventListener);
  }, []);

  return (
    <div
      className="collapsible-content"
      ref={containerRef}
      onTransitionEnd={() => {
        if (!collapsed) {
          setOverflow('visible');
        }
      }}
      style={{ height, overflow }}
    >
      <div ref={contentRef}>{children}</div>
    </div>
  );
};

CollapsibleContent.propTypes = {
  collapsed: PropTypes.bool,
  children: PropTypes.node.isRequired
};

CollapsibleContent.defaultProps = {
  collapsed: false
};

export default CollapsibleContent;
